import AccountDetail from "./AccountDetail/AccountDetail";
import AccountSecurity from "./AccountSecurity/AccountSecurity";
import SpotLiveTradeSettings from "./SpotLiveTradeSettings/SpotLiveTradeSettings";
import React from "react";
import CommunityDetail from "./CommunityDetail/CommunityDetail";
import { useSelector } from "react-redux";
import TraderDetail from "./TraderDetail/TraderDeatil";

const NewSetting = () => {
  const { user } = useSelector((state) => state.user);
  const displayComunityDetail =
    user?.role === "leader" && (user.leaderCommunity?.name||(!user?.leaderCommunity&&!user?.tradeName));
  const displayTraderDetail =
    user?.role === "leader" && (user.tradeName || user?.mainLeader?.tradeName);
    return (
    <>
      <div className="AccountSettingPage">
        {displayComunityDetail && <CommunityDetail />}
        {displayTraderDetail && <TraderDetail />}
        {/* {!user?.leaderCommunity && user?.tradeName && <TraderDetail />} */}
        <AccountDetail />
        <AccountSecurity />
        <SpotLiveTradeSettings />
      </div>
    </>
  );
};

export default NewSetting;
